export class Error {
    constructor(obj) {
        this.Error_ID = obj.Error_ID;
        this.ErrorDetails = obj.ErrorDetails;
    }
}
